<template>
    <div id="addCustomerModal" ref="addCustomerModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Add New Customer</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Type</span>
              <select class="form-select" v-model="newCustomer.type">
                <option value="customer">Customer</option>
                <option value="wholesaler">Wholesaler</option>
                <option v-if="$store.getters.access('customer_premium')" value="premium_ws">Premium Wholesaler ⭐️</option>
              </select>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="newCustomer.name">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Phone</span>
              <input class="form-control" type="text" v-model.trim="newCustomer.phone">
            </div>
            <button class="btn btn-sm btn-warning w-50 mb-2 bi-car-front-fill" @click="addCar(newCustomer.cars)">&nbsp; Add Car</button>
            <div class='input-group mb-2 border-dark ' v-for="car, i in newCustomer.cars" :key="i">
                <input class='form-control border-dark ' type='text'  placeholder='Brand' v-model=car.brand>
                <input class='form-control border-dark ' type='number' placeholder='Miles' v-model=car.miles>
                <span class="input-group-text border-dark ">Plate</span>
                <input class='form-control w-150px border-dark text-center' type='text' v-model=car.plate[3]>
                <input class='form-control w-50px border-dark text-center' type='text' v-model=car.plate[2]>
                <input class='form-control w-50px border-dark text-center' type='text' v-model=car.plate[1]>
                <input class='form-control w-50px border-dark text-center' type='text' v-model=car.plate[0]>
                <button class='btn btn-sm btn-danger bi-trash' @click="removeCar(newCustomer.cars, i)"></button>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="addCustomer()">Add</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
</template>
<!-- ******************************************************** -->
<script>
const $ = require('jquery');
export default {
    // eslint-disable-next-line
    name: 'AddCustomer',
    data(){
      return {
        loading: false,
        newCustomer:{
          type: 'customer',
          name: '',
          phone: '',
          cars: [],
        },
        callback: ()=>{},
      }
    },
    created(){
    },
    methods:{
      //**********************************************************
      async show(callback){
        this.callback = callback;
        $('#addCustomerModal').modal('show');
      },
    //**********************************************************
    async addCustomer(){
      this.$emit('update:loading', true);
      await this._addCustomer();
      this.$emit('update:loading', false);
    },
    //**********************************************************
    async _addCustomer(){
      if(!this.newCustomer.name || !this.newCustomer.phone){
        return this.$toast('Some Fields are empty', 'warning');
      }
      var ack = await this.$service.addCustomer({
        type: this.newCustomer.type,
        name: this.newCustomer.name,
        phone: this.newCustomer.phone,
        cars: this.newCustomer.cars,
      });
      if(ack.state != 'OK') return this.$toast(ack.state);
      $('#addCustomerModal').modal('hide');
      this.$toast('Customer Added Successfuly', 'success');
      this.callback(ack.data);
    },
    //**********************************************************
      addCar(array){
        array.push({
          brand: '',
          miles: '',
          plate: ['','','','']
        })
      },
      //**********************************************************
      removeCar(array, index){
        array.splice(index, 1);
      },

  }
}
</script>
<!-- ******************************************************** -->
<style scoped>
#invoice_body > p{
    margin: none !important;
}
</style>
  